import classNames from "classnames";
import React from "react";
import Spinner from "../Spinner";

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary";
  loading?: boolean;
}

const Button = ({
  className,
  children,
  variant = "default",
  loading,
  ...rest
}: IButtonProps) => {
  return (
    <button
      className={classNames(
        "px-3 py-2 text-sm font-medium leading-[21px] flex items-center justify-center gap-2 transition-colors",
        variant === "primary"
          ? "bg-secondary text-white hover:bg-[#d40080]"
          : "bg-white text-[#374151] border border-[#E5E7EB] hover:bg-[#F9FAFB]",
        rest.disabled ? "opacity-50" : "",
        className
      )}
      {...rest}
    >
      {loading && (
        <Spinner
          className={classNames(
            "h-4 w-4",
            variant === "default" ? "border-primary" : "border-white"
          )}
        />
      )}
      {children}
    </button>
  );
};

export default Button;
